import { render, staticRenderFns } from "./CategoriesNavigation.vue?vue&type=template&id=13e54982&scoped=true&"
import script from "./CategoriesNavigation.vue?vue&type=script&lang=ts&"
export * from "./CategoriesNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriesNavigation.vue?vue&type=style&index=0&id=13e54982&scoped=true&lang=css&"
import style1 from "./CategoriesNavigation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e54982",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VRow,VTab,VTabs})
